import { useRef, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Grid,
  IconButton,
  InputAdornment,
  Tooltip,
  Typography,
} from '@mui/material';
import { Info, InsertDriveFile, Delete as DeleteIcon, Close, CalendarToday } from '@mui/icons-material';
import { FilePond } from 'react-filepond';
import * as pdfjsLib from 'pdfjs-dist';

import { gcoreServerUrl, mode, toFilePreviewUrl } from '../../config';
import uploadLabels from '../../FildPondLabel';
import { FormInputCheckbox,  FormInputDate, FormInputText } from "../form";
import {
  AlertDialog,
  DialogTitleClose,
  PaperComponent,
} from "../dialog";
import { dateFormat } from "../../utils";
import * as gclientG04GeneralDocuMapActions from "../../store/gclientG04GeneralDocuMap";
import * as gclientG04docuEtcMapActions from "../../store/gclientG04docuEtcMap";
import * as g04docuFileActions from "../../store/g04docuFile";
import DocumentViewerDrawer from "../common/viewer/DocumentViewerDrawer";
// import G04docuFileAlertDialog from "./G04docuFileAlertDialog";

const today = new Date();

// 아래 form components의 name과 연계
const defaultValues = {
  startDate: today.getDateWithStartHours(),
  endDate: null,
  validYN: false,
};

let pond;
// let revertButton;
pdfjsLib.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjsLib.version}/pdf.worker.min.js`;

const G04docuFileDialogGeneralEx = ({
  openGeneral,
  setOpenGeneral,
  selectedRow,
  selectedGClientId,
  selectedGClient,
  selectedDocuFileType,
  refresh,
  deleteButton = true,
}) => {
  const processingFile = useRef(false);

  const { g04GeneralDocuId, g04docuEtcId, title, documentType, documentPath/*, startDate, endDate*/ } = selectedRow;
  const [alertInfo, setAlertInfo] = useState({});
  const [files, setFiles] = useState([]);
  const [disabled, setDisabled] = useState(true);
  const [endDate, setEndDate] = useState(null);
  const [originalDocumentPath, setOriginalDocumentPath] = useState(null);
  const [uploadedDocumentPath, setUploadedDocumentPath] = useState("");
  const [ocrEndDate, setOcrEndDate] = useState(null);
  const [documentViewerDrawerOpen, setDocumentViewerDrawerOpen] = useState(false);
  const [currentUrl, setCurrentUrl] = useState(null);
  const [displayFileName, setDisplayFileName] = useState(null);
  const [validYN, setValidYN] = useState(true);
  
  console.log(selectedRow);
  
  const handleDialogClose = async () => {
    if (uploadedDocumentPath) {
      setAlertInfo({
        titleAlert: "안내",
        messageAlert: (
          <div>
            <span>{"현재 서류가 저장되지 않은 상태입니다."}</span>
            <br/>
            <span>{"저장하지 않고 그대로 닫으시겠습니까?"}</span>
          </div>
        ),
        type: 'confirm',
        open: true,
        confirmText: "예",
        cancelText: "아니오",
        handleConfirm: async () => {
          if (originalDocumentPath !== uploadedDocumentPath) {
            try {
              await removeG04docuFile(uploadedDocumentPath);
            } catch (error) {
              console.error('Error removing document:', error);
            }
          }
          
          pond.removeFile();

          setOpenGeneral(false);
          initDialog();
        }
      });
      return;
    }
  
    setOpenGeneral(false);
    initDialog();
  };

  const initDialog = () => {
    for (const [item, value] of Object.entries(defaultValues)) {
      setValue(item, value);
    }

    // 그외 초기화할 것들은 여기서 초기화
    setFiles([]);
    setDisabled(true);
    setOriginalDocumentPath(null);
    setUploadedDocumentPath(null);
    setOcrEndDate(null);
    setValue("endDate", null);
    setEndDate(null);
    setDisabled(true);
  }

  const { handleSubmit, reset, control, setValue, getValues } = useForm({ defaultValues: defaultValues });
  
  // 데이터 관리
  const dispatch = useDispatch();

  // 일반서류
  const createGClientG04GeneralDocuMap = ({ gclientId, g04GeneralDocuId, gclient, documentPath, documentType, validYN, startDate, endDate }) => dispatch(gclientG04GeneralDocuMapActions.create({ gclientId, g04GeneralDocuId, gclient, documentPath, documentType, validYN, startDate, endDate }))
  const removeGClientG04GeneralDocuMap = ({ gclientId, documentPath }) => dispatch(gclientG04GeneralDocuMapActions.remove({ gclientId, documentPath }))
  const updateGClientG04GeneralDocuMap = ({ gclientId, g04GeneralDocuId, newDocumentPath, documentPath, validYN, startDate, endDate }) => dispatch(gclientG04GeneralDocuMapActions.modifyDate({ gclientId, g04GeneralDocuId, newDocumentPath, documentPath, validYN, startDate, endDate }))
  const removeG04docuFile = (documentPath) => g04docuFileActions.removeDirect(documentPath)

  // 기타서류
  const createGClientG04docuEtcMap = ({ gclientId, g04docuEtcId, gclient, documentPath, documentType, validYN, startDate, endDate }) => dispatch(gclientG04docuEtcMapActions.create({ gclientId, g04docuEtcId, gclient, documentPath, documentType, validYN, startDate, endDate }))
  const updateGClientG04docuEtcMap = ({ gclientId, g04docuEtcId, newDocumentPath, documentPath, validYN, startDate, endDate }) => dispatch(gclientG04docuEtcMapActions.modifyDate({ gclientId, g04docuEtcId, newDocumentPath, documentPath, validYN, startDate, endDate }))
  const removeGClientG04docuEtcMap = ({ gclientId, g04docuEtcId, documentPath }) => dispatch(gclientG04docuEtcMapActions.remove({ gclientId, g04docuEtcId, documentPath }))
  const downloadG04docuFile = (documentPath) => g04docuFileActions.downloadDirect(documentPath)

  useEffect(
    () => {
    }, [dispatch]
  )

  useEffect(
    () => {
      if (selectedRow) {
        for (const [item, value] of Object.entries(defaultValues)) {
          if (item === "startDate" || item === "endDate") {
            const newValue = selectedRow[item] ? new Date(selectedRow[item]) : value;
            setValue(item, newValue);
            if (item === "endDate") {
              setEndDate(newValue);
              if (newValue) {
                // endDate 값 존재시 validYN 값 false로 설정
                setValidYN(false);
              } else {
                // endDate 값 없을 시 validYN 값 true로 설정
                setValidYN(true);
              }
            }
          } else {
            setValue(item, selectedRow[item] || value);
          }
        }

        // 그외 설정할 것들은 여기서 한다.
        selectedRow["endDate"] && documentPath && setDisabled(false);
      }

      //서류 파일명 표시
      if (selectedRow?.documentPath) {
        setDisplayFileName(documentPath.split('/').pop());
        setOriginalDocumentPath(documentPath);
      } else {
        setDisplayFileName(null);
      }      
    }, [selectedRow]
  );

  // return 값에 유의. true => 값 변경, false => 현재값 유지
  const handleChangePeriod = (value, name) => {
    console.log(name, value)
    console.log({ files, documentPath, disabled });
    if ((documentPath) && (name === "endDate" ? value : getValues("endDate"))) {
      setDisabled(false);
    } else {
      setDisabled(true);
    }
    setValue(name, value);
    if (value) {
      setValidYN(false); // 날짜 선택시 false
    } else {
      setValidYN(true);  // 날짜 미선택시 true
    }
    if (name === "endDate") {
      setEndDate(value);
    }
    return true;
  }
  
  // 삭제 버튼 핸들러
  const handleClickDelete = async () => {
    setAlertInfo({
      titleAlert: "안내",
      messageAlert: "서류를 삭제하시겠습니까?",
      type: 'confirm',
      open: true,
      confirmText: "예",
      cancelText: "아니오",
      handleConfirm: async () => {
        if (selectedDocuFileType === 'GENERAL') {
          await removeGClientG04GeneralDocuMap({ 
            gclientId: selectedGClientId, 
            documentPath 
          });
        } else if (selectedDocuFileType === 'ETC') {
          await removeGClientG04docuEtcMap({ 
            gclientId: selectedGClientId, 
            g04docuEtcId,
            documentPath 
          });
        }
        if (documentPath) {
          await removeG04docuFile(documentPath);
        }
        refresh(selectedGClientId);
        setOpenGeneral(false);
      }
    });
  };

  const formatDateToKorean = (date) => {
    if (!date) return "";
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${year}년 ${month}월 ${day}일`;
  };

  // 서류저장 버튼 핸들러
  const handleClickSave = (mode) => {
    const startDate = getValues("startDate")? dateFormat(getValues("startDate").getDateWithStartHours()) : null;
    const endDate = getValues("endDate") ? dateFormat(getValues("endDate").getDateWithEndHours()) : null;
    const validYN = endDate ? false : true;
    const today = new Date().setHours(0,0,0,0);
    const displayEndDate = formatDateToKorean(endDate);
    const displayToday = formatDateToKorean(today);

    console.log("handleClickSave", {documentPath, uploadedDocumentPath});

    // 신규는 서류를 첨부
    if (!documentPath && !uploadedDocumentPath) {
      setAlertInfo({
        titleAlert: "안내",
        messageAlert: "서류가 첨부되지 않았습니다. 서류를 첨부해 주세요.",
        open: true
      });
      return;
    }

    // NATIONAL_TAX, LOCAL_TAX 서류 타입인 경우 endDate 검증
    if ((documentType === 'NATIONAL_TAX' || documentType === 'LOCAL_TAX') && !endDate) {
      setAlertInfo({
        titleAlert: "안내",
        messageAlert: "서류 만료일을 입력해주세요.",
        open: true
      });
      return;
    }

    // endDate가 현재일보다 작은지 체크
    //if (endDate && new Date(endDate) < today) {
    if (false) {
      setAlertInfo({
        titleAlert: "안내",
        messageAlert: (
          <div>
            <span style={{color: 'blue'}}>서류 만료일({displayEndDate})</span>은 <span style={{color: 'red'}}>현재일({displayToday})</span> 보다 이전일 수 없습니다.
          </div>
        ),
        open: true
      });
      return;
    }

    
    try {
      if (endDate) {
        setAlertInfo({
          titleAlert: "안내", 
          messageAlert: (
            <div>
              {/* 만료일만 수정일 경우 */}
              {documentPath && !uploadedDocumentPath ? (
              <div>
                <div>서류 만료일은 <span style={{color: 'blue'}}>{displayEndDate}</span> 입니다.</div>
                <div style={{paddingTop: '10px'}}>서류를 첨부하지 않고 만료일만 수정하시겠습니까?</div>
              </div>
              ) : (
              <div>
                <div>서류 만료일은 <span style={{color: 'blue'}}>{displayEndDate}</span> 입니다.</div>
                <div style={{paddingTop: '10px'}}>서류(<span style={{color: 'blue'}}>{displayFileName}</span>)를 저장하시겠습니까?</div>
              </div>
            )}
            </div>
          ),
          type: 'confirm',
          open: true,
          confirmText: "예",
          cancelText: "아니오",
          handleConfirm: async () => {
            handleClickSaveAction(startDate, endDate, validYN);
          }
        });
      } else {
        // 만료일 없음
        setAlertInfo({
          titleAlert: "안내",
          messageAlert: (
            <div>
              <div style={{paddingTop: '10px'}}>서류(<span style={{color: 'blue'}}>{displayFileName}</span>)를 저장하시겠습니까?</div>
            </div>
          ),
          type: 'confirm',
          open: true,
          confirmText: "예",
          cancelText: "아니오",
          handleConfirm: async () => {
            handleClickSaveAction(startDate, null, validYN);
          }
        });
      }
    } catch (error) {
      console.error('Error saving document:', error);
    }
  }

  // 서류저장 버튼 핸들러 API 호출
  const handleClickSaveAction = async (startDate, endDate, validYN) => {
    console.log("handleClickSaveAction",  endDate, validYN, documentPath, uploadedDocumentPath);
    // 수정  
    if (documentPath) {
      if (selectedDocuFileType === 'GENERAL') {
        await updateGClientG04GeneralDocuMap({
          gclientId: selectedGClientId,
          g04GeneralDocuId,
          newDocumentPath: uploadedDocumentPath,
          documentPath: documentPath,
          validYN: validYN,
          startDate: startDate,
          endDate: endDate,
        });
      } else if (selectedDocuFileType === 'ETC') {
        await updateGClientG04docuEtcMap({
          gclientId: selectedGClientId,
          g04docuEtcId,
          newDocumentPath: uploadedDocumentPath,
          documentPath: documentPath,
          validYN: validYN,
          startDate: startDate,
          endDate: endDate,
        });
      }

      refresh(selectedGClientId);
      setOpenGeneral(false); // handleDialogClose() 대신 직접 dialog를 닫음
      initDialog();

      // 서류명이 변경된 경우 이전 서류 삭제 : modifyDate API 호출시 서버에서 파일을 삭제함.
      // if (uploadedDocumentPath && documentPath !== uploadedDocumentPath) {
      //   console.log("documentPath !== uploadedDocumentPath", documentPath, uploadedDocumentPath);
      //   await removeG04docuFile(documentPath);
      // }
    } 
    // 신규
    else {
      if (selectedDocuFileType === 'GENERAL') {
        await createGClientG04GeneralDocuMap({
          gclientId: selectedGClientId,
          g04GeneralDocuId,
          gclient: selectedGClient,
          documentPath: uploadedDocumentPath,
          documentType,
          validYN: validYN,
          startDate: startDate,
          endDate: endDate
        });
      } else if (selectedDocuFileType === 'ETC') {
        await createGClientG04docuEtcMap({
          gclientId: selectedGClientId,
          g04docuEtcId,
          gclient: selectedGClient,
          documentPath: uploadedDocumentPath,
          documentType,
          validYN: validYN,
          startDate: startDate ,
          endDate: endDate
        });
      }

      refresh(selectedGClientId);
      setOpenGeneral(false); // handleDialogClose() 대신 직접 dialog를 닫음
      initDialog();
    }
  }

  return (
    <>
      <Dialog
        open={openGeneral}
        onClose={handleDialogClose}
        PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
        fullWidth={true}
        maxWidth="sm"
      >
        <DialogTitleClose
          id="draggable-dialog-title"
          onClose={handleDialogClose}
          style={{ cursor: 'move' }}
        >
          {/* {`${title} ${documentPath ? '수정' : '등록'}`} */}
          {`${title} 첨부`}
        </DialogTitleClose>
        <DialogContent>
          {/* <ul>
            {errors.map((error, idx) => <li key={idx}>{error}</li>)}
          </ul> */}
          <Grid container spacing={2}>
            {/* 만료일 출력 */}
            <Grid item xs={12}>
              <Grid container spacing={1}>
                <Grid item xs={6}>
                  <FormInputDate
                    name="endDate"
                    control={control}
                    label={validYN ? "서류 만료일 없음" : "서류 만료일"}
                    onChangePeriodValue={handleChangePeriod}
                    value={endDate}
                    setValue={setValue}
                    getValues={getValues}
                    // onEdit={checkEdit}
                    inputHeight={38}
                    clearable={true}
                  />
                </Grid>
                {/* <Grid item xs={6} display="flex" justifyContent={"flex-start"} alignItems={"center"} sx={{ display: selectedRow?.documentType === 'NATIONAL_TAX' || selectedRow?.documentType === 'LOCAL_TAX' ? 'none' : 'flex' }}>
                  <FormInputCheckbox
                    name="validYN"
                    control={control}
                    setValue={setValue}
                    onChangeCheckValue={handleChangeCheckButton}
                  />
                  <Typography>{"만료일 없음"}</Typography>
                </Grid>*/}
              </Grid> 
            </Grid>
            {/* 파일명 출력 */}
            <Grid item xs={12}>
              <Typography sx={{ display: 'flex', alignItems: 'center', color: uploadedDocumentPath ? 'primary.main' : 'text.secondary' }}>
                {displayFileName ? (
                  <>
                    <InsertDriveFile sx={{ mr: 1, fontSize: 20, color: uploadedDocumentPath ? 'primary.main' : 'text.secondary' }} />
                    {displayFileName}
                  </>
                ) : (
                  ''
                )}
              </Typography>
              {/* <FormInputText
                name="displayFileName"
                control={control}
                label="서류명"
                fullWidth
                size="small"
                value={displayFileName || ''}
                disabled
                sx={{
                  '& .MuiInputBase-input': {
                    color: uploadedDocumentPath ? 'primary.main' : 'text.secondary'
                  },
                  '& .MuiOutlinedInput-root': {
                    '&.Mui-disabled': {
                      '& .MuiOutlinedInput-input': {
                        color: uploadedDocumentPath ? 'primary.main' : 'text.secondary',
                        WebkitTextFillColor: uploadedDocumentPath ? '#2e7d32' : '#666666'
                      }
                    }
                  }
                }}
              /> */}
            </Grid>
            <Grid item xs={12}>
            {uploadedDocumentPath && (
              <Box sx={{ 
                display: 'flex', 
                alignItems: 'center',
                color: '#2e7d32',
                fontSize: '14px'
              }}>
                <Info sx={{ mr: 1 }} />
                {documentType === 'NATIONAL_TAX' || documentType === 'LOCAL_TAX' ? (
                  <>
                    파일 업로드가 완료 되었습니다. <br />서류 만료일 확인 후 [서류저장] 버튼을 클릭하여 서류첨부를 완료해 주세요.
                  </>
                ) : (
                  <>
                    파일 업로드가 완료 되었습니다. <br /> 
                    - 서류만료일 존재: 서류 만료일 선택 후 [서류저장] 버튼을 클릭하여 서류첨부를 완료해주세요. <br />
                    - 서류만료일 미존재: [서류저장] 버튼을 클릭하여 서류첨부를 완료해 주세요.
                  </>
                )}
              </Box>
            )}
            </Grid>
            {/* 파일 업로드 */}
            <Grid item xs={12}>
              <FilePond
                  ref={ref => pond = ref}
                  files={files}
                  credits={false}
                  allowMultiple={false}
                  allowReplace={false}
                  allowProcess={false}
                  allowRevert={false}
                  instantUpload={true}  // 즉시 업로드 활성화
                  acceptedFileTypes={['image/*', 'application/pdf']}
                  onupdatefiles={setFiles} // onupdatefiles(files)
                  labelIdle={uploadLabels.labelIdle} // 기본 업로드 메시지만 유지
                  server={{
                    url: gcoreServerUrl,
                    timeout: 700000,
                    process: {
                        url: `/api/g04docuFiles/uploadFile`,
                        headers: {
                          Authorization: `Bearer ${sessionStorage.getItem('accessToken')}`,
                        },
                        // 요청 전 데이터 가공
                        ondata: (formData) => {
                          formData.append('gclientId', selectedGClientId);
                          formData.append('gclientName', selectedGClient?.name);
                          formData.append('docuFileType', selectedDocuFileType);
                          // 주의 : build하면 files가 []임. 원인파악 안됨. 확인결과 pond.getFiles()는 사용가능하여 이 코드로 대체
                          // formData.append('fileName', files[0].filename); // TODO : 한글 파일명인 경우 filepond를 그대로 쓸 경우 서버에서 인코딩 문제가 발생. 현재 해결 못하여 fileName을 설정함
                          formData.append('fileName', (pond.getFiles())[0].filename); // TODO : 한글 파일명인 경우 filepond를 그대로 쓸 경우 서버에서 인코딩 문제가 발생. 현재 해결 못하여 fileName을 설정함
                         
                          let newEndDate = getValues('endDate');
                          newEndDate = newEndDate ? dateFormat(newEndDate.getDateWithEndHours()) : null;
                          if (newEndDate) {
                            formData.append('endDate', newEndDate);
                          }
                          formData.append('docuCode', documentType);

                          let validYN = false;
                          if (documentType === 'NATIONAL_TAX' || documentType === 'LOCAL_TAX') {
                            validYN = true;
                          } else if (!newEndDate) {
                            // const validYN = endDate ? false : true;
                            validYN = true;
                          }
                          formData.append('validYN', validYN);
                          // formData.append('endDate', getValues('endDate')); // 이렇게 보내면 null이 string으로 전달됨
                          
                          // console.log(formData);
                          return formData;
                        },
                        // 업로드 완료
                        onload: async (res) => { // 서버에서 api 동작 후 리턴되는 callback
                          console.log(res)
                          const response = JSON.parse(res);
                          console.log ("response.file : ", response.file, "uploadedDocumentPath : ", uploadedDocumentPath);

                          // 파일을 계속 업로드 할 경우 이전에 업로드한 파일 삭제
                          if (uploadedDocumentPath) {
                            // 원본 파일명과 업로드 파일 비교, 이전 업로드 파일과 현재 업로드 파일 비교
                            if (documentPath !== uploadedDocumentPath && uploadedDocumentPath !== response.file) {
                              await removeG04docuFile(uploadedDocumentPath)
                                  .then(() => {
                                      console.log("이전 업로드 파일 삭제 완료 ......");
                                      return true; // 계속 진행
                                  })
                                  .catch(err => {
                                      console.error("이전 파일 삭제 실패:", err);
                                      return true; // 오류가 있어도 계속 진행
                                  });
                            }
                          }

                          //console.log("업로드 완료 후 임시 파일 설정 완료 ......");
                          // setDisplayFileName((pond.getFiles())[0]?.filename || (pond.getFiles())[0]?.file?.name); // 파일명 표시
                          setDisplayFileName(response.file.split('/').pop());
                          setUploadedDocumentPath(response.file);
                          
                          // 서류 미리보기 표시
                          setCurrentUrl(toFilePreviewUrl(response.file));
                          setDocumentViewerDrawerOpen(true);

                          // 서류 만료일 자동 판독
                          if (documentType === 'NATIONAL_TAX' || documentType === 'LOCAL_TAX') {
                            if (response.endDate) { // OCR 판독 성공
                              const parsedDate = new Date(response.endDate);
                              setOcrEndDate(parsedDate);
                              setValue('endDate', parsedDate);
                              setEndDate(parsedDate);
                              setDisabled(false);
                              setValidYN(false);
                            } else { // OCR 판독 실패
                              // setAlertInfo({
                              //   titleAlert: "안내",
                              //   messageAlert: "만료일을 자동으로 판독하지 못했습니다. 직접 만료일을 입력해주세요.",
                              //   open: true,
                              // });
                              alert("만료일을 자동으로 판독하지 못했습니다.\n직접 만료일을 입력해주세요.");

                              setValue('endDate', null);
                              setEndDate(null);
                              setDisabled(true);
                            }
                          } 
                          
                          // FilePond 초기화 및 files 상태 초기화
                          if (pond) {
                            pond.removeFiles();
                            setFiles([]);
                          }

                          return res;
                        }, 
                        // 업로드 오류
                        onerror: (res) => {
                          console.log(res);
                          if (typeof res === 'string') {
                            let needAlert = false;
                            const jsonRes = JSON.parse(res);
                            if (jsonRes.code === 43001 || jsonRes.code === '43001') {
                              needAlert = true;
                            }

                            if (needAlert) {
                              setAlertInfo({
                                titleAlert: "안내",
                                messageAlert: (
                                  <div>
                                    <span style={{ color: "#d32f2f" }}><i><u>{"서류 만료일"}</u></i></span>
                                    <span>{"이 유효하지 않습니다."}</span>
                                  </div>
                                ),
                                open: true,
                              });
                            }
                          }
                        },
                    },
                    revert: {
                      url: `/api/g04docuFiles/deleteFile`,
                      method: 'DELETE',
                      // 중요: 아래 헤더가 없으면 backend에서 req.body를 얻지 못함
                      headers: {
                        Authorization: `Bearer ${sessionStorage.getItem('accessToken')}`,
                      },
                      ondata: (formData) => {
                        // documentPath만 전달
                        return {
                          documentPath: documentPath
                        };
                      },
                    },
                  }}
                >
              </FilePond>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          {documentPath && (
            <>
              {deleteButton && !uploadedDocumentPath && (
                <Button onClick={handleClickDelete} sx={{ ml: '15px' }}>서류삭제</Button>
              )}
              <Box sx={{ flex: 1 }} /> {/* 스페이서 */}
            </>
          )}
          <Button onClick={handleClickSave}>서류저장</Button>
          <Button onClick={handleDialogClose}>닫기</Button>
        </DialogActions>
      </Dialog>
      {/* <G04docuFileAlertDialog /> */}
      <AlertDialog
        alertInfo={alertInfo}
        setAlertInfo={setAlertInfo}
      />
      <DocumentViewerDrawer 
        open={documentViewerDrawerOpen}
        onClose={() => setDocumentViewerDrawerOpen(false)}
        url={currentUrl}
      />
    </>
  );
};

export default G04docuFileDialogGeneralEx;
